import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import {
  DirectLinkSource,
  TOOLKIT_TYPE,
  useNavigateToWellnessToolkit as useNavigateToWellnessToolkitShared,
  WELLNESS_TOOLKIT_PROMOTION,
} from '@lyrahealth-inc/shared-app-logic'

import { useAppDispatch } from '../../data/storeConfiguration/store'
import { setDirectLinkSource, setToolkitType } from '../../features/onboard/data/onboardDataActions'

export const useNavigateToWellnessToolkit = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const navigateToWellnessToolkit = useNavigateToWellnessToolkitShared({
    setToolkitType: (toolkitPromotion: TOOLKIT_TYPE) => dispatch(setToolkitType(toolkitPromotion)),
    setDirectLinkSource: (directLinkSource) => dispatch(setDirectLinkSource(directLinkSource)),
    navigateToToolkit: (toolkitPromotion, navigationParams) =>
      navigate(`/secure/wellness/toolkit/${toolkitPromotion}`, {
        state: navigationParams,
      }),
  })

  return useCallback(
    ({
      toolkitPromotion,
      directLinkSource,
      navigationParams,
    }: {
      toolkitPromotion: WELLNESS_TOOLKIT_PROMOTION
      directLinkSource: DirectLinkSource
      navigationParams?: { onBackPressed?: () => void; mixpanelEntryPoint?: string }
    }) => {
      navigateToWellnessToolkit({ toolkitPromotion, directLinkSource, navigationParams })
    },
    [navigateToWellnessToolkit],
  )
}
